import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');

  if (!token) {
    router.navigate(['/login']);
    return false;
  }

  let userType = '';
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      userType = user.user_type?.toLowerCase() || '';
    } catch { }
  }

  const allowedRoles = route.data?.['roles'] as Array<string>;
  
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userType)) {
      router.navigate(['/dashboard']);
      return false;
    }
  }

  return true;
};